import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { OtherUseService } from 'cbd-proxies';
import { ProtectedAreaService } from '../proxy/geographic/controllers';

FieldBuilder.setNamespace('Geographic');

export const PROTECTEDAREAOTHERUSEDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('area', 'Entity.ProtectedAreaOtherUseDetail.Area')
    .decimal()
    .readOnly()
    .sortable(false)
    .filterable(false)
    .build(),
  FieldBuilder.foreignKey(
    'protectedAreaId',
    'Entity.ProtectedArea',
    ProtectedAreaService
  )
    .required()
    .displayFromNested('protectedAreaName')
    .sortBy('protectedAreaName')
    .build(),
  FieldBuilder.foreignKey(
    'otherUseId',
    'Entity.OtherUse',
    OtherUseService
  )
    .required()
    .display('name')
    .displayFromNested('otherUseName')
    .sortBy('otherUseName')
    .keyField('id')
    .build(),
];

export const PROTECTEDAREAOTHERUSEDETAIL_CONFIG = {
  entityName: 'ProtectedAreaOtherUseDetail',
  localizationKey: 'Geographic::Entity.ProtectedAreaOtherUseDetail',
  fields: PROTECTEDAREAOTHERUSEDETAIL_FIELDS,
  permission: 'PlanningGeography.ProtectedAreaOtherUseDetails',
  showInMenu: false,
};
